import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'

import { USER_LOGGED_OUT } from '../actions'

import form from './form'
import user from './user'
import campaigns from './campaign'
import missions from './Missions'
import layout from './layout'
import ui from './ui'

const appReducer = combineReducers({
  form,
  layout,
  user,
  campaigns,
  missions,
  routing,
  ui,
})

const rootReducer = (state, action) => {
  if (action.type === USER_LOGGED_OUT) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.jsx